import { render } from "./YourYogaCare.vue?vue&type=template&id=6f7f82ac&scoped=true"
import script from "./YourYogaCare.vue?vue&type=script&lang=js"
export * from "./YourYogaCare.vue?vue&type=script&lang=js"

import "./YourYogaCare.vue?vue&type=style&index=0&id=6f7f82ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7f82ac"]])

export default __exports__